var hooxSliderReviews = document.querySelector(".hoox-reviews__items");
var hooxSliderReviewsLength = document.querySelectorAll(
  ".hoox-reviews__items .hoox-reviews__item"
).length;

if (hooxSliderReviews) {
  var slider = new Swiper(hooxSliderReviews, {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        centeredSlides: true,
        loop: true,
        spaceBetween: 20,
      },
    },

    pagination: {
      el: ".hoox-reviews__dots",
      clickable: true,
    },
    navigation: {
      nextEl: ".hoox-swiper-reviews-arrow-next",
      prevEl: ".hoox-swiper-reviews-arrow-prev",
    },
  });
}
